import React from "react";
import { useSectors } from "newui/store/common-types";
import { SelectWithLabel, BaseSelectWithLabelProps, SelectOption } from "../InputWithLabel/SelectWithLabel";
import { useFormikFieldState } from "./useFormikField";

interface SectorSelectProps
  extends Omit<BaseSelectWithLabelProps, "options" | "isLoading"> {
  byCompanyId?: number;
  selectedIds?: number[];
}

export const SectorSelect: React.FC<SectorSelectProps> = ({
  label = "Sectors",
  placeholder = "Select sector",
  byCompanyId,
  selectedIds,
  value: valueProp,
  hasError: hasErrorProp,
  errorText: errorTextProp,
  onChange: onChangeProp,
  name,
  ...rest
}) => {
  const { values, isLoading } = useSectors(byCompanyId);
  const formik = useFormikFieldState(name);

  const resolvedValue = selectedIds && !isLoading
    ? selectedIds
        .map((id) => values.find((s) => s.value === id))
        .filter(Boolean) as SelectOption[]
    : selectedIds && isLoading
      ? undefined
      : valueProp;

  const handleChange = (selected: SelectOption | SelectOption[] | null) => {
    formik.markTouched();
    onChangeProp?.(selected);
  };

  return (
    <SelectWithLabel
      options={values as SelectOption[]}
      isLoading={isLoading}
      label={label}
      placeholder={placeholder}
      value={resolvedValue}
      name={name}
      hasError={hasErrorProp || formik.hasError}
      errorText={errorTextProp || formik.errorText}
      onChange={handleChange}
      {...rest}
    />
  );
};
